// ============================================================
// Cat „cantareste" un text pe X (10 octombrie 2026, X_PLAN.md).
//
// X nu numara literele, ci greutati:
//   * un link valoreaza MEREU 23, oricat de lung sau de scurt ar fi;
//   * un emoji valoreaza 2, chiar si cand e facut din mai multe semne lipite;
//   * literele latine, cu diacritice cu tot, ghilimelele „ " si liniuta — valoreaza 1;
//   * restul (de pilda „…" ca un singur semn, chineza, japoneza) valoreaza 2.
// Plafonul unui cont obisnuit e 280.
//
// Aceeasi socoteala sta si pe server, in `supabase/functions/_shared/x.ts`. Cine o schimba
// aici o schimba si acolo.
//
// Unde gresim, gresim in partea sigura: un domeniu scris fara „https://" (newmind.ro) il
// socotim link, fiindca X il face clicabil singur.
// ============================================================

export const LIMITA_X = 280;
const GREUTATE_LINK = 23;

// Adrese cu protocol, si domenii goale cu o terminatie cunoscuta.
// Fara „lookbehind": Safari mai vechi de 16.4 nu il stie si ar pica toata aplicatia la incarcare.
const LINK = /https?:\/\/[^\s]+|(^|[^@\w.-])((?:[a-z0-9-]+\.)+(?:ro|com|org|net|eu|md|gov|edu|info|io|co|app|tv|me|uk|de|fr|it|es|hu|bg|news|online|site)(?![\w-])(?:\/[^\s]*)?)/gi;

const USOARE = [[0, 4351], [8192, 8205], [8208, 8223], [8242, 8247]];
const EMOJI = /\p{Extended_Pictographic}|\p{Regional_Indicator}/u;

function greutateSemn(cod) {
  return USOARE.some(([a, b]) => cod >= a && cod <= b) ? 1 : 2;
}

function greutateBucata(bucata) {
  let total = 0;
  const grafeme = typeof Intl !== 'undefined' && Intl.Segmenter
    ? Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(bucata), g => g.segment)
    : Array.from(bucata);
  for (const g of grafeme) {
    if (EMOJI.test(g)) { total += 2; continue; }
    for (const semn of g) total += greutateSemn(semn.codePointAt(0));
  }
  return total;
}

export function areLinkPeX(text) {
  LINK.lastIndex = 0;
  return LINK.test(text || '');
}

export function lungimePeX(text) {
  const curat = (text || '').normalize('NFC');
  let total = 0;
  let deUnde = 0;
  LINK.lastIndex = 0;
  for (const m of curat.matchAll(LINK)) {
    // La un domeniu gol, potrivirea incepe cu semnul dinaintea lui, care se numara separat.
    const inceput = m.index + (m[1] ? m[1].length : 0);
    total += greutateBucata(curat.slice(deUnde, inceput)) + GREUTATE_LINK;
    deUnde = m.index + m[0].length;
  }
  return total + greutateBucata(curat.slice(deUnde));
}
